// @ts-nocheck
import { useDispatch, useSelector } from "react-redux";
import { ReimbursementModal } from "../../../contractor-side/ScheduleTab/tabs/ReimbursementModal";
import {
  closeDeductionModalAction,
  closeNonTaxableModalAction,
  closeReimbursementModalAction,
} from "../../../../store/actions/event/adjustments";
import { useMemo } from "react";
import {
  groupDeductionsByContractor,
  groupNonTaxableChargesByCategoryType,
  groupReimbursementsByContractor,
} from "../../../../appCalcutions";
import { DeductionModal } from "../../../contractor-side/ScheduleTab/tabs/DeductionModal";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { NonTaxableModal } from "../../../contractor-side/ScheduleTab/tabs/NonTaxableModal";
import { isUserRole, isActiveRole } from "../../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../../staticData/userRoles";

export default function EventAdjustmentWrapper() {
  const dispatch = useDispatch();
  const { eventInfo } = useSelector((state) => state?.eventRequestDetails);
  const { adjustmentWrapper, eventAdjustments } = useSelector(
    (state) => state?.adjustmentsReducer,
  );

  const {
    open,
    isReimbursement,
    positionDetails,
    contractorDetails,
    isNonTax,
    taxCategory,
    openDraft,
  } = adjustmentWrapper;

  const list = useMemo(() => {
    if (isReimbursement) {
      return (
        groupReimbursementsByContractor({
          reimbursements: eventAdjustments?.reimbursements || [],
          contractorArr: eventAdjustments?.allContractorsDetails || [],
        })?.find((r) =>
          contractorDetails?._id
            ? r?.contractorId == contractorDetails?._id
            : r?.positionId == positionDetails?._id,
        )?.reimbursements || []
      );
    } else if (isNonTax) {
      return (
        groupNonTaxableChargesByCategoryType({
          nonTaxableCharges:
            adjustmentWrapper?.customNonTaxableCharges ||
            eventAdjustments?.nonTaxableCharges ||
            [],
        })?.find((r) => r?.categoryType == taxCategory)?.nonTaxableCharges || []
      );
    } else {
      return (
        groupDeductionsByContractor({
          deductions: eventAdjustments?.deductions || [],
          contractorArr: eventAdjustments?.allContractorsDetails || [],
        })?.find((r) =>
          contractorDetails?._id
            ? r?.contractorId == contractorDetails?._id
            : r?.positionId == positionDetails?._id,
        )?.deductions || []
      );
    }
  }, [
    adjustmentWrapper.customNonTaxableCharges,
    eventAdjustments,
    isReimbursement,
    contractorDetails?._id,
    positionDetails?._id,
    isNonTax,
    taxCategory,
  ]);

  // if (!eventInfo?._id) {
  //   return null;
  // }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {isUserRole(
        USER_ROLES.SUPERADMIN,
        USER_ROLES.ADMIN,
        USER_ROLES.COORDINATOR,
      ) && (
        <ReimbursementModal
          user={"admin"}
          open={open && isReimbursement}
          handleClose={() => {
            dispatch(closeReimbursementModalAction());
          }}
          data={list ? list : []}
          eventId={eventInfo?._id}
          otherData={{
            eventId: eventInfo?._id,
            contractorDetails: contractorDetails,
            positionDetails: positionDetails,
          }}
          openDraft={openDraft}
          title="Reimbursement Records"
        />
      )}
      {isUserRole(
        USER_ROLES.SUPERADMIN,
        USER_ROLES.ADMIN,
        USER_ROLES.COORDINATOR,
      ) && (
        <DeductionModal
          user={"admin"}
          open={open && !isReimbursement && !isNonTax}
          handleClose={() => {
            dispatch(closeDeductionModalAction());
          }}
          data={list}
          eventId={eventInfo?._id}
          otherData={{
            eventId: eventInfo?._id,
            contractorDetails: contractorDetails,
            positionDetails: positionDetails,
          }}
          openDraft={openDraft}
          title="Deduction Records"
        />
      )}
      <NonTaxableModal
        user={
          adjustmentWrapper?.hidePlus
            ? "contractor"
            : isActiveRole(USER_ROLES.CLIENT)
              ? "contractor"
              : "admin"
        }
        open={open && isNonTax && !isReimbursement}
        handleClose={() => {
          dispatch(closeNonTaxableModalAction());
        }}
        openDraft={openDraft}
        data={list}
        eventId={eventInfo?._id}
        title="Non Taxable Charges"
      />
    </LocalizationProvider>
  );
}